module.exports = __webpack_public_path__ + "img/db.e9cb08b5.svg";